// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Custom styles for SoftBox
import SoftBoxRoot from "components/SoftBox/SoftBoxRoot";

const SoftBox = ({
  variant = "contained",
  bgColor,
  color = "dark",
  opacity = 1,
  borderRadius = "none",
  shadow = "none",
  ref,
  ...rest
}) => (
  <SoftBoxRoot
    {...rest}
    ref={ref}
    ownerState={{ variant, bgColor, color, opacity, borderRadius, shadow }}
  />
);
// Typechecking props for the SoftBox
SoftBox.propTypes = {
  variant: PropTypes.oneOf(["contained", "gradient"]),
  bgColor: PropTypes.string,
  color: PropTypes.string,
  opacity: PropTypes.number,
  borderRadius: PropTypes.string,
  shadow: PropTypes.string
};

export default SoftBox;
